import { useQuery } from "@tanstack/react-query";
import { dtoToUser } from "models/user";
import { useClientContext } from "clients";

export const listUsersAndPendingInvitesQueryKey = "listUsersAndPendingInvites";

/**
 * Hook for getting list of users and pending invites
 * for the organization the current user belongs to.
 *
 * caller needs to be an organization admin
 *
 * @param {(string | number)[]} queryKey
 * @returns {useQuery<{users: User[], pendingInvites: User[]}, BaseError>}
 */
const useListUsersAndPendingInvites = (queryKey?: (string | number)[]) => {
  const clients = useClientContext();
  const queryResult = useQuery({
    queryKey: queryKey ?? [listUsersAndPendingInvitesQueryKey],
    queryFn: () =>
      clients.management.listUsers().then((res) => {
        return {
          pendingInvites: res.pending_invites.map(dtoToUser),
          users: res.users.map(dtoToUser),
        };
      }),
  });

  return queryResult;
};

export default useListUsersAndPendingInvites;
